module.exports = __webpack_public_path__ + "img/des_distanceday_4.23525566.jpg";